import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithSessionId } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) {
      navigate("/connexion", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await loginWithSessionId(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true, state: { user } });
      } catch {
        navigate("/connexion", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 rounded-full border-2 border-[#00D4FF] border-t-transparent animate-spin" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Connexion sécurisée…</p>
      </div>
    </div>
  );
}
